import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { screens } from '../screens';
import { TabNavigator } from './TabNavigator';
import {PublicRoute} from'../components/PublicRoute';
import {PrivateRoute} from'../components/PrivateRoute';

export const StackNavigator: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<screens.Preview />} />

      {/* Public Routes */}
      <Route path="/login" element={<PublicRoute><screens.SignIn /></PublicRoute>} />
      <Route path="/SignUp" element={<PublicRoute><screens.SignUp /></PublicRoute>} />

      <Route path="/SendPhoneOtp" element={<PublicRoute><screens.SendPhoneOtp /></PublicRoute>} />
      <Route path="/SendEmailOtp" element={<PublicRoute><screens.SendEmailOtp /></PublicRoute>} />
      <Route path="/VerifyEmail" element={<PublicRoute><screens.VerifyEmail /></PublicRoute>} />
      <Route path="/VerifyPhone" element={<PublicRoute><screens.VerifyPhone /></PublicRoute>} />

      {/* Private Routes */}
      <Route path="/home" element={<PrivateRoute><TabNavigator /></PrivateRoute>} />
      <Route path="/brands" element={<PrivateRoute><screens.Brands/></PrivateRoute>} />
      <Route path="/products-categories" element={<PrivateRoute><screens.ProductCategories/></PrivateRoute>} />
      <Route path="/EditProfile" element={<PrivateRoute><screens.EditProfile /></PrivateRoute>} />
      <Route path="/Product" element={<PrivateRoute><screens.Product /></PrivateRoute>} />
      <Route path="/Shop" element={<PrivateRoute><screens.Shop /></PrivateRoute>} />
      <Route path="/Reviews" element={<PrivateRoute><screens.Reviews /></PrivateRoute>} />
      <Route path="/Description" element={<PrivateRoute><screens.Description /></PrivateRoute>} />
      <Route path="/OrderHistory" element={<PrivateRoute><screens.OrderHistory /></PrivateRoute>} />
      <Route path="/Checkout" element={<PrivateRoute><screens.Checkout /></PrivateRoute>} />
      <Route path="/OrderSuccessful" element={<PrivateRoute><screens.OrderSuccessful /></PrivateRoute>} />
      <Route path="/OrderFailed" element={<PrivateRoute><screens.OrderFailed /></PrivateRoute>} />
      <Route path="/MyPromocodes" element={<PrivateRoute><screens.MyPromocodes /></PrivateRoute>} />
      <Route path="/ShippingAndPaymentInfo" element={<PrivateRoute><screens.ShippingAndPaymentInfo /></PrivateRoute>} />
      <Route path="/InfoSaved" element={<PrivateRoute><screens.InfoSaved /></PrivateRoute>} />
      <Route path="/LeaveAReview" element={<PrivateRoute><screens.LeaveAReview /></PrivateRoute>} />
      <Route path="/MyPromocodesEmpty" element={<PrivateRoute><screens.MyPromocodesEmpty /></PrivateRoute>} />
      <Route path="/Filter" element={<PrivateRoute><screens.Filter /></PrivateRoute>} />
      <Route path="/OrderHistoryEmpty" element={<PrivateRoute><screens.OrderHistoryEmpty /></PrivateRoute>} />
      {/* <Route path="/EmailVerified" element={<PrivateRoute><screens.EmailVerified /></PrivateRoute>} />
      <Route path="/PhoneVerified" element={<PrivateRoute><screens.PhoneVerified /></PrivateRoute>} /> */}
      <Route path="/SignOut" element={<PrivateRoute><screens.SignOut /></PrivateRoute>} />
    </Routes>
  );
};
